/** http://dalelotts.github.io/angular-bootstrap-datetimepicker/
 * decorator
 */

import moment from 'moment';
import DateUtil from 'gw-portals-util-js/DateUtil';

function getValidDateOrNull(dateParam) {
    var date = void 0;
    if (typeof dateParam === 'undefined') {
        date = null;
    } else {
        date = new Date(dateParam);
        // check if date object is invalid;
        if (isNaN(date.getTime())) {
            date = null;
        }
    }
    return date;
}

export default ['$provide', 'dateTimePickerConfig', function ($provide, dateTimePickerConfig) {
    $provide.decorator('datetimepickerDirective', ['$delegate', '$timeout', function ($delegate, $timeout) {
        var directive = $delegate[0];

        /* ----- INTERNAL DATEPICKER'S METHODS START ----- */
        function DateObject() {
            var tempDate = DateUtil.currentDate();
            var localOffset = tempDate.getTimezoneOffset() * 60000;
            this.utcDateValue = tempDate.getTime();
            this.selectable = true;

            this.localDateValue = function () {
                return this.utcDateValue + localOffset;
            };

            var validProperties = ['utcDateValue', 'localDateValue', 'display', 'active', 'selectable', 'past', 'future'];

            for (var prop in arguments[0]) {
                /* istanbul ignore else */
                // noinspection JSUnfilteredForInLoop
                if (validProperties.indexOf(prop) >= 0) {
                    // noinspection JSUnfilteredForInLoop
                    this[prop] = arguments[0][prop];
                }
            }
        }

        var getUTCTime = function getUTCTime(modelValue) {
            var tempDate = modelValue ? moment(modelValue).toDate() : DateUtil.currentDate();
            return tempDate.getTime() - tempDate.getTimezoneOffset() * 60000;
        };
        /* ----- INTERNAL DATEPICKER'S METHODS END ----- */

        directive.compile = function () {
            return function (scope, element, attrs, ngModelController) {
                directive.link.apply(this, arguments);
                var parentScope = scope.$parent;

                // support the default date
                function updateDefaultDate(newDate, oldDate) {
                    if (oldDate !== newDate) {
                        if (angular.isDate(newDate)) {
                            $timeout(function () {
                                scope.changeView(parentScope.startView, new DateObject({
                                    utcDateValue: newDate.getTime()
                                }));
                            });
                        }
                    }
                }

                updateDefaultDate(parentScope.defaultDate);
                parentScope.$watch('defaultDate', updateDefaultDate);

                // add support for max-date and min-date to the picker
                scope.beforeRender = function (picker) {
                    var dates = picker.$dates;
                    var view = picker.$view; // hour, day, month or year
                    var maxDate = getValidDateOrNull(parentScope.maxDate);
                    var minDate = getValidDateOrNull(parentScope.minDate);
                    // extend range for each view
                    if (maxDate) {
                        maxDate = moment(maxDate).endOf(view).valueOf();
                    }
                    if (minDate) {
                        minDate = moment(minDate).startOf(view).valueOf();
                    }
                    // make items outside of the range not selectable
                    dates.forEach(function (dateObject) {
                        var date = dateObject.utcDateValue;
                        var isGreaterThanMaxDate = maxDate && date > maxDate;
                        var isLesserThanMinDate = minDate && date < minDate;
                        if (isGreaterThanMaxDate || isLesserThanMinDate) {
                            dateObject.selectable = false;
                        }
                    });
                };
                scope.$root.$on('$translateChangeSuccess', function () {
                    // RESET VIEW TO BE UPDATED WITH THE NEW LOCALE
                    scope.changeView(dateTimePickerConfig.startView, new DateObject({
                        utcDateValue: getUTCTime(ngModelController.$viewValue)
                    }));
                });
            };
        };

        return $delegate;
    }]);
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/datetimepicker/datepickerDecorator.js
// module id = 1102
// module chunks = 0